/*! playlist-view.js */
import BaseView from "./base-view";
import ResizeMonitor from "app/utils/resize-monitor";

/**
 * @class PlaylistView
 */
class PlaylistView extends BaseView {

    /**
     * @constructs PlaylistView
     */
    constructor() {
        super();

        this.resizeMonitor = new ResizeMonitor(this.el_);
        this.resizeMonitor.setEventParent(this);
    }

    /**
     * @method
     */
    createEl() {
        return super.createEl("div", "bvp-playlist-player", {
            "data-breakpoints": "320 640 800",
            innerHTML: `
    <div class="bvp-playlist-player__container">
       <div class="bvp-playlist-slide"></div>
       <div class="bvp-playlist-slide bvp-playlist-slide__preload"></div>
    </div>
    `
        });
    }

    /**
     * @override
     */
    dispose() {
        this.resizeMonitor.dispose();
        this.resizeMonitor = null;

        super.dispose();
    }
}

export default PlaylistView;
